import { ListItem, Checkbox, ListItemText } from "@mui/material";

interface IFilterCheckboxItemProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export const FilterCheckboxItem = (props: IFilterCheckboxItemProps) => {
  const { label, checked, onChange, disabled } = props;
  const labelId = `checkbox-list-label-${label}`;
  return (
    <ListItem dense disableGutters>
      <Checkbox
        slotProps={{
          input: {
            "aria-labelledby": labelId,
          },
        }}
        checked={checked}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          onChange(e.target.checked);
        }}
        disabled={disabled}
      />
      <ListItemText
        id={labelId}
        primary={label}
        sx={{
          paddingLeft: 1,
          overflowX: "hidden",
          overflowWrap: "anywhere",
        }}
      />
    </ListItem>
  );
};
